import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { useNavigate, Route, Routes } from "react-router";
import Swal from "sweetalert2";
import { privateRoutes, publicRoutes } from "./router.link";
import Feature from "../feature-module/feature";
import AuthFeature from "../feature-module/authFeature";
import Login from "../feature-module/auth/login/login";
import axiosInstance from "../services/axiosInstance";
import { store } from "../redux/store";
import {
  logout,
  updateAccessToken,
  updateRefreshToken,
} from "../redux/slicers/authSlice";
import { refreshAccessToken } from "../services/authService";
import NoAccess from "./NoAccess";
import Error404 from "./Error404";

const ALLRoutes: React.FC = () => {
 // const navigate = useNavigate();
  // const { t } = useTranslation();

  // useEffect(() => {
  //   const interceptor = axiosInstance.interceptors.response.use(
  //     (response) => response,
  //     async (error) => {
  //       const originalRequest = error.config;

  //       // 🔁 Attempt token refresh on 401
  //       if (error.response?.status === 401 && !originalRequest._retry) {
  //         originalRequest._retry = true;
  //         try {
  //           const {
  //             accessToken: newAccessToken,
  //             refreshToken: newRefreshToken,
  //           } = await refreshAccessToken();

  //           store.dispatch(updateAccessToken(newAccessToken));
  //           store.dispatch(updateRefreshToken(newRefreshToken));

  //           originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
  //           return axiosInstance(originalRequest);
  //         } catch (refreshError) {
  //           Swal.fire({
  //             icon: "warning",
  //             title: t("session_expired"),
  //             text: t("please_log_in_again"),
  //           });
  //           store.dispatch(logout());
  //           navigate("/login");
  //           return Promise.reject(
  //             refreshError instanceof Error
  //               ? refreshError
  //               : new Error("Session expired")
  //           );
  //         }
  //       }

  //       // 🎯 Handle ASSIGNMENT_CONFLICT specifically
  //       const responseData = error.response?.data;
  //       if (
  //         responseData?.code === "ASSIGNMENT_CONFLICT" &&
  //         Array.isArray(responseData.details)
  //       ) {
  //         Swal.fire({
  //           icon: "error",
  //           title: t(error.response?.data?.code || "request_failed"),
  //           html: Array.isArray(error.response?.data?.details)
  //             ? `<ul style="text-align: left; padding-left: 1.2em;">${error.response.data.details
  //                 .map((d: string) => `<li>${d}</li>`)
  //                 .join("")}</ul>`
  //             : error.response?.data?.message || t("unexpected_error"),
  //         });

  //         return Promise.reject(error);
  //       }

  //       // ❌ Default error fallback
  //       Swal.fire({
  //         icon: "error",
  //         title: t("request_failed"),
  //         text: responseData?.message || t("unexpected_error"),
  //       });

  //       return Promise.reject(
  //         error instanceof Error
  //           ? error
  //           : new Error(error?.message || t("unexpected_error"))
  //       );
  //     }
  //   );

  //   return () => {
  //     axiosInstance.interceptors.response.eject(interceptor);
  //   };
  // }, [navigate]);
  const generateRoutes = (routes: any) =>
    routes.map((route: any, idx: any) => {
      const { path, element, children } = route;

      return (
        <Route path={path} element={element} key={idx}>
          {children && generateRoutes(children)}{" "}
        </Route>
      );
    });
  return (
    <Routes>      
      <Route path="*" element={<Error404 />} />
      <Route path="/" element={<Login />} />
      <Route path="/no-access" element={<NoAccess />} />
      <Route element={<Feature />}>{generateRoutes(privateRoutes)}</Route>
      <Route element={<AuthFeature />}>{generateRoutes(publicRoutes)}</Route>
    </Routes>
  );
};

export default ALLRoutes;
